import { AdCarouselWithText } from './AdCarouselWithText';

import type { AdCarouselWithTextProps } from './AdCarouselWithText';

export default {
  title: 'Organisms/AdCarouselWithText',
  component: AdCarouselWithText
};

const args = {
  headline: 'Become the best version of yourself',
  ratio: {
    mobile: 1,
    tablet: 1.5,
    desktop: 2.5
  },
  etrustedData: {
    aggregateRating: {
      count: 935,
      rating: 4.68
    },
    aggregateRatingTotal: {
      count: 32312,
      rating: 4.82
    },
    infoUrl:
      'https://www.trustedshops.de/bewertung/info_XEB05F7A1D7ED3F1880AE9AADE537750E.html?utm_source=shop&utm_medium=link&utm_content=TrustmarkCellNo1__trustmark_and_reviews&utm_campaign=trustbadge_maximised'
  },
  adSlides: [
    {
      image: '/vitafy/about-us/header01.png',
      imageMedium: '/vitafy/about-us/header-tablet/Header_Image_01.jpg',
      imageSmall: '/vitafy/about-us/header-mobile/Header_Image_01.jpg',
      trackingLabel: 'trackingLabel',
      caption: 'caption1'
    },
    {
      image: '/vitafy/about-us/header02.png',
      imageMedium: '/vitafy/about-us/header-tablet/Header_Image_02.jpg',
      imageSmall: '/vitafy/about-us/header-mobile/Header_Image_02.jpg',
      trackingLabel: 'trackingLabel',
      caption: 'caption2'
    },
    {
      image: '/vitafy/about-us/header05.png',
      imageMedium: '/vitafy/about-us/header-tablet/Header_Image_03.jpg',
      imageSmall: '/vitafy/about-us/header-mobile/Header_Image_03.jpg',
      trackingLabel: 'trackingLabel',
      caption: 'caption3'
    },
    {
      image: '/vitafy/about-us/header06.png',
      imageMedium: '//vitafy/about-us/header-tablet/Header_Image_04.jpg',
      imageSmall: '/vitafy/about-us/header-mobile/Header_Image_04.jpg',
      trackingLabel: 'trackingLabel',
      caption: 'caption4'
    },
    {
      image: '/vitafy/about-us/header07.png',
      imageMedium: '/vitafy/about-us/header-tablet/Header_Image_05.jpg',
      imageSmall: '/vitafy/about-us/header-mobile/Header_Image_05.jpg',
      trackingLabel: 'trackingLabel',
      caption: 'caption5'
    }
  ]
};

export const Default = {
  args: args satisfies AdCarouselWithTextProps
};
